import StartIcon from '@mui/icons-material/Start';
import { Avatar, Box } from '@mui/material';
import { blue, grey } from '@mui/material/colors';
import { Handle, Position, useConnection, useReactFlow } from '@xyflow/react';
import React from 'react';

import { ContactFlowNode, ContactFlowNodeProps } from '..';

export default function EntryNode({ id }: ContactFlowNodeProps) {
  const { getHandleConnections } = useReactFlow<ContactFlowNode>();
  const hConn = getHandleConnections({
    type: 'source',
    nodeId: id,
    id,
  });
  const conn = useConnection();
  const noConnection = hConn.length < 1;
  return (
    <Box>
      <Avatar
        sx={{
          backgroundColor: grey[900],
        }}>
        <StartIcon />
      </Avatar>
      <Handle
        id={id}
        type='source'
        position={Position.Right}
        style={{
          width: 14,
          height: 14,
          background: (
            conn.inProgress
              ? conn.fromHandle.id === id || (noConnection && conn.fromHandle.type == 'target')
              : noConnection
          )
            ? blue[600]
            : grey[500],
        }}
        isConnectable={noConnection}
      />
    </Box>
  );
}
